import { HandleError } from '../../infrastructure/handleError';
import { MsgService } from '../local/msg.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseModel } from '../../models/models/response.model';
import { Observable } from 'rxjs';

// @Injectable()
export class BaseService extends HandleError {
    constructor(
        protected messageService: MsgService,
        protected httpClient: HttpClient,
        protected urlName: string,
        protected apiName: string
    ) {
        super(messageService);
    }

    async getCustomApi(apiMethod: string, params: HttpParams): Promise<ResponseModel> {
        return await this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/${apiMethod}`, { params }).toPromise();
    }

    async postCustomApi(apiMethod: string, model: object): Promise<ResponseModel> {
        return await this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/${apiMethod}`, model).toPromise();
    }
    public postAny(apiMethod: string, model: Object): Observable<any> {
        let options: any = { responseType: "blob" };
        return this.httpClient.post<any>(`${this.urlName}/${this.apiName}/${apiMethod}`, model, options);
    }
}
